<script setup>
/* eslint-disable no-unused-vars */
/* global defineProps, defineEmits */
import FormBenefit from "@/views/benefits/FormBenefit.vue";
import Services from "@/api/services/benefit";

import { getCurrentInstance, onMounted, ref } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const instance = getCurrentInstance();

const benefit = ref({});

const loading = ref(true);

function getSuggestion() {
  const id = route.params.id;
  Services.getOne(id).then(resp => {
    benefit.value = resp.data;
  }).finally(() => {
    loading.value = false;
  });
}

onMounted(() => {
  loading.value = true;
  getSuggestion();
});
</script>

<template>
  <div v-if="!loading">
    <FormBenefit
      :update="true"
      :benefit="benefit"
    />
  </div>
</template>